import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { ProveedorService, MenuFuncionService, PaisService, TenantService } from '../../../../src/app/shared/services';
import { ActividadPrincipal, GridPageSettings, LocalStorageKeys, MenuFuncionCodes, Pais, SearchActividadPrincipalRequest, SearchPaisRequest, SearchProveedorRequest, TenantFeatureFlags } from '../../../../src/app/shared/model';
import { DatePipe } from '@angular/common';
import { ActividadPrincipalService } from '../../../../src/app/shared/services/actividad-principal.service';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-proveedores-lista',
  templateUrl: './proveedores-lista.component.html',
  styleUrls: ['./proveedores-lista.component.scss']
})
export class ProveedoresListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isPaisSearching: boolean = false;
  isActividadSearching: boolean = false;

  canView: boolean = false;
  canAdd: boolean = false;
  verSoloActivos: boolean = true;

  public query: Query;

  paisesList: Pais[];
  actividadList: ActividadPrincipal[];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private menuService: MenuFuncionService,
    private paisService: PaisService,
    private actividadPrincipalService: ActividadPrincipalService,
    private tenantService: TenantService,
    private service: ProveedorService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.PROVEEDOR).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        if (data.Result.some(x => x == MenuFuncionCodes.PROVEEDOR_LIST)) {
          this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
            this.isValidating = false;
            if (dataTenant != null && dataTenant.Success) {
              this.tenantFeatureFlags = dataTenant.Result;

              this.canAdd = data.Result.some(x => x == MenuFuncionCodes.PROVEEDOR_ADD);
              this.canView = data.Result.some(x => x == MenuFuncionCodes.PROVEEDOR_LIST);

              this.loadView();
            }
          },
          (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.router.navigate(['/']);
        }
      } 
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
    

    this.buildForm();
    this.getPaises();
    this.getActividad();

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'RazonSocial': [null],
      'Codigo': [null],
      'Cuit': [null],
      'PaisId': [null],
      'ActividadId': [null]
    });
  }

  getPaises() {
    this.paisService.search(new SearchPaisRequest(null,null,null,null,null,null,true)).subscribe(data => {
      this.isPaisSearching = false;
      this.paisesList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isPaisSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  getActividad() {
    this.isActividadSearching = true;
    this.actividadPrincipalService.search(new SearchActividadPrincipalRequest(null,null,null,null,null,null,true)).subscribe(data => {
      this.isActividadSearching = false;
      this.actividadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isPaisSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Codigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Codigo;
    else
      this.query.addParams("Codigo",this.searchForm.value.Codigo);
    
    index = this.query.params.findIndex(obj => obj.key === "RazonSocial");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.RazonSocial;
    else
      this.query.addParams("RazonSocial", this.searchForm.value.RazonSocial);

    index = this.query.params.findIndex(obj => obj.key === "Cuit");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Cuit;
    else
      this.query.addParams("Cuit",this.searchForm.value.Cuit);

    index = this.query.params.findIndex(obj => obj.key === "PaisId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PaisId;
    else
      this.query.addParams("PaisId",this.searchForm.value.PaisId);

    index = this.query.params.findIndex(obj => obj.key === "ActividadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ActividadId;
    else
      this.query.addParams("ActividadId",this.searchForm.value.ActividadId);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos",this.verSoloActivos.toString());
  }

  add() {
    if (this.canAdd) {
      this.router.navigate(['proveedores-edit', 0]);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para crear un nuevo proveedor", "Error");
    }
  }

  edit(item: any) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['proveedores-edit', item.Id]);
  }

  onExport() {
    var search = new SearchProveedorRequest(null, null, null, "", null, null, null, null, null, null, this.verSoloActivos);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Proveedores_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}

